import React, { useEffect, useState } from 'react';
import {
    Container,
    Box,
    Typography,
} from '@mui/material';
import { getRequest } from "../../Fetch/request";



const ProfilePage = () => {
    const [userProfile, setUserProfile] = useState({});
    const [isLoading, setIsLoading] = useState(true);

    const fetchData = async () => {
        try {
            const userId = localStorage.getItem('userId') || (JSON.parse(localStorage.getItem('profileObject') || '{}').id) || 'slazysloth_user';
            
            // First try to get from localStorage
            const profileData = JSON.parse(localStorage.getItem("profileObject"));
            
            if (profileData && profileData.id) {
                // Use localStorage data if available
                setUserProfile({
                    email: profileData.email || '',
                });
            } else if (userId) {
                // Fetch fresh data from backend if no localStorage data
                const getResponse = await getRequest(`${process.env.REACT_APP_URL}/user/getUser?userId=${userId}`);
                if (getResponse.status === "200" && getResponse.response != null && getResponse.response.length > 0) {
                    const formObject = getResponse.response[0];
                    localStorage.setItem("profileObject", JSON.stringify(formObject));
                    
                    setUserProfile({
                        email: formObject.email || '',
                    });
                }
            }
        } catch (error) {
            // Handle error silently - show empty profile
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);



    return (
        <Container maxWidth="md" sx={{ mt: 5 }}>
            {isLoading ? (
                <Box sx={{ 
                    display: 'flex', 
                    justifyContent: 'center', 
                    alignItems: 'center', 
                    height: '50vh',
                    fontSize: '18px'
                }}>
                    Loading profile...
                </Box>
            ) : (
                <>
                {/* Profile Card */}
            <Box
                sx={{
                    backgroundColor: '#fff',
                    padding: '30px',
                    borderRadius: '12px',
                    boxShadow: '0px 8px 20px rgba(0, 0, 0, 0.1)',
                    textAlign: 'center',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                }}
            >
                {/* Email Only */}
                <Typography variant="body1" sx={{ color: '#666', fontSize: '18px' }}>
                    {userProfile.email || 'No email available'}
                </Typography>
            </Box>
                </>
            )}
        </Container>
    );
};

export default ProfilePage;
